const getClientId = () => window.EMP?.MSAL_CLIENT_ID;
const getTenantId = () => window.EMP?.MSAL_TENANT_ID;
const getBackendAppId = () => window.EMP?.MSAL_BACKEND_APP || null;
const getBackendScopeName = () => window.EMP?.MSAL_BACKEND_SCOPE || "emp-ui";

export const msalConfig = {
  auth: {
    clientId: getClientId(),
    authority: `https://login.microsoftonline.com/${getTenantId()}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: true,
  },
};

export const getBackendScopes = () => {
  const appId = getBackendAppId();
  if (!appId) {
    throw new Error(
      "MSAL_BACKEND_APP is not configured in window.EMP. " +
        "Set window.EMP.MSAL_BACKEND_APP to the Azure AD application ID of the backend service."
    );
  }
  return [`api://${appId}/${getBackendScopeName()}`];
};
